import {
  CloneWishlistType,
  RequestCreateWishlistType,
  RequestUpdateWishlistNameType,
  ResponseCallbackReturnType,
  WishlistDetailedType,
} from 'b2b-common/core/account/api/wishlists';
import { AddItemsToCartType } from 'b2b-common/core/cart/api/CartTypes';
import {
  ADD_TO_WISHLIST,
  ADD_TO_WISHLIST_FULFILLED,
  ADD_TO_WISHLIST_REJECTED,
  ADD_WISHLIST_ITEMS_TO_CART,
  ADD_WISHLIST_ITEMS_TO_CART_FULFILLED,
  ADD_WISHLIST_ITEMS_TO_CART_REJECTED,
  CLEAR_ACCOUNT_WISHLIST,
  CLEAR_ADD_WISHLIST_ITEMS_TO_CART,
  CLEAR_CLONE_WISHLIST,
  CLONE_WISHLIST,
  CLONE_WISHLIST_FULFILLED,
  CLONE_WISHLIST_REJECTED,
  CREATE_AND_ADD_TO_WISHLIST,
  CREATE_WISHLIST,
  FETCH_WISHLIST,
  FETCH_WISHLIST_FULFILLED,
  FETCH_WISHLIST_REJECTED,
  REMOVE_WISHLIST,
  REMOVE_WISHLIST_ITEM,
  REMOVE_WISHLIST_ITEMS,
  REMOVE_WISHLIST_ITEMS_FULFILLED,
  REMOVE_WISHLIST_ITEMS_REJECTED,
  UPDATE_WISHLIST_ITEM_QUANTITY,
  UPDATE_WISHLIST_ITEM_REFERENCE,
  UPDATE_WISHLIST_NAME,
  UPDATE_WISHLIST_REFERENCE,
} from './actionTypes';
import {
  AddItemsToCartAction,
  AddItemsToCartFulfilledAction,
  AddItemsToCartRejectedAction,
  AddToWishlistAction,
  AddToWishlistFulfilledAction,
  AddToWishlistRejectedAction,
  ClearAccountWishlistAction,
  ClearAddItemsToCartAction,
  ClearCloneWishlistAction,
  CloneWishlistAction,
  CloneWishlistFulfilledAction,
  CloneWishlistRejectedAction,
  CreateAndAddToWishlistAction,
  CreateWishlistAction,
  FetchWishlistAction,
  FetchWishlistFulfilledAction,
  FetchWishlistRejectedAction,
  RemoveWishlistAction,
  RemoveWishlistItemAction,
  RemoveWishlistItemsAction,
  RemoveWishlistItemsFulfilledAction,
  RemoveWishlistItemsRejectedAction,
  UpdateWishlistItemQuantityAction,
  UpdateWishlistItemReferenceAction,
  UpdateWishlistNameAction,
  UpdateWishlistReferenceAction,
} from './types';

export const addItemsToCart = (wishlistId: string, items: string[] = []): AddItemsToCartAction => ({
  type: ADD_WISHLIST_ITEMS_TO_CART,
  payload: {
    wishlistId,
    items,
  },
});

export const addItemsToCartFulfilled = (
  wishlistId: string, response: AddItemsToCartType,
): AddItemsToCartFulfilledAction => ({
  type: ADD_WISHLIST_ITEMS_TO_CART_FULFILLED,
  payload: {
    wishlistId,
    data: response,
  },
});

export const addItemsToCartRejected = (wishlistId: string, error: ErrorType): AddItemsToCartRejectedAction => ({
  type: ADD_WISHLIST_ITEMS_TO_CART_REJECTED,
  payload: {
    wishlistId,
    error,
  },
});

export const addToWishlist = (
  wishlistId: string, skus: string[], callback: ResponseCallbackReturnType,
): AddToWishlistAction => ({
  type: ADD_TO_WISHLIST,
  payload: {
    wishlistId,
    skus,
    callback,
  },
});

export const addToWishlistFulfilled = (): AddToWishlistFulfilledAction => ({
  type: ADD_TO_WISHLIST_FULFILLED,
});

export const addToWishlistRejected = (): AddToWishlistRejectedAction => ({
  type: ADD_TO_WISHLIST_REJECTED,
});

export const cloneWishlist = (wishlistId: string, name: string): CloneWishlistAction => ({
  type: CLONE_WISHLIST,
  payload: {
    wishlistId,
    name,
  },
});

export const cloneWishlistFulfilled = (response: CloneWishlistType): CloneWishlistFulfilledAction => ({
  type: CLONE_WISHLIST_FULFILLED,
  payload: {
    data: response,
  },
});

export const cloneWishlistRejected = (error: ErrorType): CloneWishlistRejectedAction => ({
  type: CLONE_WISHLIST_REJECTED,
  payload: {
    error,
  },
});

export const createAndAddToWishlist = (
  newWishlistName: string, skus: string[], callback: ResponseCallbackReturnType,
): CreateAndAddToWishlistAction => ({
  type: CREATE_AND_ADD_TO_WISHLIST,
  payload: {
    newWishlistName,
    skus,
    callback,
  },
});

export const createWishlist = (
  data: RequestCreateWishlistType, callback: ResponseCallbackReturnType,
): CreateWishlistAction => ({
  type: CREATE_WISHLIST,
  payload: {
    data,
    callback,
  },
});

export const fetchWishlist = (wishlistId: string): FetchWishlistAction => ({
  type: FETCH_WISHLIST,
  payload: {
    wishlistId,
  },
});

export const fetchWishlistFulfilled = (
  wishlistId: string, response: WishlistDetailedType,
): FetchWishlistFulfilledAction => ({
  type: FETCH_WISHLIST_FULFILLED,
  payload: {
    wishlistId,
    data: response,
  },
});

export const fetchWishlistRejected = (wishlistId: string, error: ErrorType): FetchWishlistRejectedAction => ({
  type: FETCH_WISHLIST_REJECTED,
  payload: {
    wishlistId,
    error,
  },
});

export const updateWishlistName = (
  wishlistId: string, data: RequestUpdateWishlistNameType, callback: ResponseCallbackReturnType,
): UpdateWishlistNameAction => ({
  type: UPDATE_WISHLIST_NAME,
  payload: {
    wishlistId,
    data,
    callback,
  },
});

export const updateWishlistReference = (reference: string, wishlistId: string): UpdateWishlistReferenceAction => ({
  type: UPDATE_WISHLIST_REFERENCE,
  payload: {
    reference,
    wishlistId,
  },
});

export const removeWishlist = (wishlistId: string, callback: ResponseCallbackReturnType): RemoveWishlistAction => ({
  type: REMOVE_WISHLIST,
  payload: {
    wishlistId,
    callback,
  },
});

export const updateWishlistItemQuantity = (
  wishlistId: string, sku: string, quantity: number,
): UpdateWishlistItemQuantityAction => ({
  type: UPDATE_WISHLIST_ITEM_QUANTITY,
  payload: {
    wishlistId,
    sku,
    quantity,
  },
});

export const updateWishlistItemReference = (
  wishlistId: string, sku: string, reference: string,
): UpdateWishlistItemReferenceAction => ({
  type: UPDATE_WISHLIST_ITEM_REFERENCE,
  payload: {
    wishlistId,
    sku,
    reference,
  },
});

export const removeWishlistItem = (wishlistId: string, sku: string): RemoveWishlistItemAction => ({
  type: REMOVE_WISHLIST_ITEM,
  payload: {
    wishlistId,
    sku,
  },
});

export const removeWishlistItems = (wishlistId: string, skus: string[]): RemoveWishlistItemsAction => ({
  type: REMOVE_WISHLIST_ITEMS,
  payload: {
    wishlistId,
    skus,
  },
});

export const removeWishlistItemsFulfilled = (wishlistId: string): RemoveWishlistItemsFulfilledAction => ({
  type: REMOVE_WISHLIST_ITEMS_FULFILLED,
  payload: {
    wishlistId,
  },
});

export const removeWishlistItemsRejected = (
  wishlistId: string, error: ErrorType,
): RemoveWishlistItemsRejectedAction => ({
  type: REMOVE_WISHLIST_ITEMS_REJECTED,
  payload: {
    wishlistId,
    error,
  },
});

export const clearAccountWishlist = (): ClearAccountWishlistAction => ({
  type: CLEAR_ACCOUNT_WISHLIST,
});

export const clearAddItemsToCart = (): ClearAddItemsToCartAction => ({
  type: CLEAR_ADD_WISHLIST_ITEMS_TO_CART,
});

export const clearCloneWishlist = (): ClearCloneWishlistAction => ({
  type: CLEAR_CLONE_WISHLIST,
});
